import React, { useState, useMemo } from "react";
import Plot from "react-plotly.js";

const companies = [
  { name: "Yellow", baseX: 20, baseY: 70, priceFactor: 0.9, reliabilityFactor: 0.3, color: "#f4b400" },
  { name: "Pulse", baseX: 40, baseY: 60, priceFactor: 0.5, reliabilityFactor: 0.8, color: "#e91e63" },
  { name: "Cognito", baseX: 55, baseY: 45, priceFactor: 0.3, reliabilityFactor: 0.4, color: "#ff6f61" },
  { name: "Manto", baseX: 65, baseY: 50, priceFactor: 0.7, reliabilityFactor: 0.2, color: "#00796b" },
  { name: "Ada", baseX: 80, baseY: 55, priceFactor: 0.4, reliabilityFactor: 0.9, color: "#1e88e5" },
];

const PricingReliabilityGraph = () => {
  const [price, setPrice] = useState(50);

  // 🔹 New sliders
  const [integration, setIntegration] = useState(50);
  const [coverage, setCoverage] = useState(50);

  // 🔹 Derived Reliability
  const reliability = useMemo(() => {
    return (integration + coverage) / 2;
  }, [integration, coverage]);

  const computed = useMemo(() => {
    return companies.map((c) => ({
      x: Math.max(0, Math.min(100, c.baseX + (price - 50) * c.priceFactor)),
      y: Math.max(
        0,
        Math.min(100, c.baseY + (reliability - 50) * c.reliabilityFactor)
      ),
    }));
  }, [price, reliability]);

  return (
    <div style={{ padding: 20, maxWidth: 900, margin: "0 auto" }}>
      <h2>Pricing vs Reliability</h2>

      <Plot
        data={[
          {
            x: computed.map((c) => c.x),
            y: computed.map((c) => c.y),
            text: companies.map((c) => c.name),
            mode: "markers+text",
            type: "scatter",
            textposition: "middle center",
            marker: {
              size: 45,
              color: companies.map((c) => c.color),
              line: { width: 1.5, color: "#111" },
              opacity: 0.95,
            },
          },
        ]}
        layout={{
          width: 800,
          height: 500,
          margin: { l: 80, r: 30, t: 50, b: 80 },
          xaxis: {
            range: [0, 100],
            fixedrange: true,
            title: { text: `Pricing (${price})`, font: { size: 16 } },
          },
          yaxis: {
            range: [0, 100],
            fixedrange: true,
            title: { text: `Reliability (${reliability})`, font: { size: 16 } },
          },
          showlegend: false,
          transition: { duration: 400, easing: "cubic-in-out" },
        }}
        config={{ responsive: true, displayModeBar: false }}
        animate
      />

      <div style={{ marginTop: 40 }}>
        
        {/* 🔹 Pricing */}
        <div style={{ marginBottom: 30 }}>
          <label style={{ fontWeight: 600 }}>
            Pricing: {price}
          </label>
          <input
            type="range"
            min="0"
            max="100"
            value={price}
            onChange={(e) => setPrice(Number(e.target.value))}
            style={{ width: "100%" }}
          />
        </div>

        {/* 🔹 Integration */}
        <div style={{ marginBottom: 20 }}>
          <label style={{ fontWeight: 600 }}>
            Integration: {integration}
          </label>
          <input
            type="range"
            min="0"
            max="100"
            value={integration}
            onChange={(e) => setIntegration(Number(e.target.value))}
            style={{ width: "100%" }}
          />
        </div>

        {/* 🔹 Coverage */}
        <div style={{ marginBottom: 20 }}>
          <label style={{ fontWeight: 600 }}>
            Coverage: {coverage}
          </label>
          <input
            type="range"
            min="0"
            max="100"
            value={coverage}
            onChange={(e) => setCoverage(Number(e.target.value))}
            style={{ width: "100%" }}
          />
        </div>

        {/* 🔹 Derived Output */}
        <div style={{ fontWeight: 700, fontSize: 18 }}>
          Final Reliability Score: {reliability}
        </div>

      </div>
    </div>
  );
};

export default PricingReliabilityGraph;